import React from 'react';
import PropTypes from 'prop-types';

const ImageSingle = (props) => {
    let src = '';
    if (props.options.type === 'left') {
        src = props.sources.left;
    } else if (props.options.type === 'right') {
        src = props.sources.right;
    }
    return (
        <img src={src} alt={''}/>
    );
};

ImageSingle.propTypes = {
    sources: PropTypes.object,
    options: PropTypes.string
};

export default ImageSingle;
